import { useContext, useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { SystemMessageContext } from '../../../context/SystemMessageContext'
import Affiliate from '../../../templates/Affiliate/Affiliate'
import AffiliateSearch from '../../../components/AffiliateSearch/AffiliateSearch'
import Campaign from '../../../templates/Campaign/Campaign'
import CampaignSearch from '../../../components/CampaignSearch/CampaignSearch'
import callAPI from '../../../helpers/callAPI'

export default function DirectLinkModal({ showModal, setShowModal, refetch, mode, initAffiliate, initCampaign }){
    
    const { showSystemMessage } = useContext(SystemMessageContext)
    const [campaign, setCampaign] = useState(initCampaign.id > 0 ? { id: initCampaign.id, name: initCampaign.name } : false)
    const [affiliate, setAffiliate] = useState(initAffiliate.id > 0 ? { id: initAffiliate.id, name: initAffiliate.name } : false)

    const addDirectLink = async () => {
        if (affiliate.id > 0 && campaign.id > 0) {

            const postBody = {
                affiliate_id: parseInt(affiliate.id),
                campaign_id: parseInt(campaign.id)
            }

            let result = await callAPI(`affiliates/directAffiliates`, 'POST', postBody, false, showSystemMessage)

            if (result.success) {
                showSystemMessage('success', result.message)
                setShowModal(false)
                refetch()
            } else {
                showSystemMessage('error', result.message)
            }
        } else {
            showSystemMessage('error', 'Please select an affiliate and a campaign')
        }
    }

    return (
        <Modal show={showModal} onHide={()=>{ setShowModal(false); refetch() }}>
            <Modal.Header closeButton>
                <Modal.Title>Add {mode === 'affiliate' ? 'Campaign' : mode === 'campaign' ? 'Affiliate' : 'Affiliate/Campaign'} Using Direct Link</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                    <span>Affiliate</span>
                    <div className="w-75">
                        { mode === 'affiliate'
                        ?
                            <Affiliate aid={initAffiliate.id} name={initAffiliate.name} status={initAffiliate.status.value} priority={initAffiliate.priority.value} />
                        :
                            <div><AffiliateSearch affiliate={affiliate} setAffiliate={setAffiliate} order={5} /></div>
                        }
                    </div>
                </div>       
                <div className="d-flex justify-content-between align-items-center w-100 mb-2">
                    <span>Campaign</span>
                    <div className="w-75">
                        { mode === 'campaign'
                        ?
                            <Campaign oid={initCampaign.id} name={initCampaign.name} status={initCampaign.status.value} />
                        :
                            <div><CampaignSearch campaign={campaign} setCampaign={setCampaign} order={1} /></div>
                        }
                    </div>
                </div>      
            </Modal.Body>
            <Modal.Footer>
               <button className="btn btn-primary" onClick={()=>addDirectLink()}>Add {mode === 'affiliate' ? 'Campaign' : mode === 'campaign' ? 'Affiliate' : 'Affiliate/Campaign'}</button>
            </Modal.Footer>
        </Modal>
    )
}